<bn-loading-overlay></bn-loading-overlay>
<div class="container">
  <form [formGroup]="formGroup" class="form">

    <div class="row">
      <div class="col">
        <h3> {{ modoEdicao ? 'Cadastro':'Editar'}} Limite Adicional</h3>
      </div>
      <div class="col-auto">
        <button type="button" class="btn " [ngClass]="formGroup.pristine ? 'btn-primary' : 'btn-danger' "
          (click)="voltarParaLista ()"> {{ modoEdicao ? "Cancelar" : "Voltar"}}
        </button>

        <button *ngIf="modoEdicao" type="button" class="btn btn-success no-margin"
          [disabled]="formGroup.pristine || !formGroup.valid || !temPeloMenosUmPrograma()" (click)="salvar ()">Salvar
        </button>

        <button *ngIf="permissaoEdicao && !modoEdicao" type="button" class="btn btn-primary"
          (click)="habilitarEdicao ()">Editar
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 bn-form-group">
        <label class="form-label"><b>Limite Adicional</b></label>
        <input class="form-control" name="nome" formControlName="nome" [readOnly]="model?.id">
      </div>

      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataInicioProtocolo">
          <b>Data início validade</b>
        </label>
          <i class="fa fa-question-circle ms-1 cursor-pointer"
            ngbTooltip="Data de início da SOG"
            placement="top"
            aria-hidden="true"></i>
        <bn-datepicker formControlName="dataInicioProtocolo" name="dataInicio" idInput="dataInicioProtocolo"></bn-datepicker>
        <small class="text-danger"
          *ngIf="formGroup.get('dataInicioProtocolo')?.errors?.['dataInicioProtocoloInvalida'] && formGroup.get('dataInicioProtocolo')?.dirty">
          {{formGroup.get('dataInicioProtocolo')?.errors?.['dataInicioProtocoloInvalida']}}</small>
      </div>

      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataFim"><b>Data final validade</b></label>
        <bn-datepicker formControlName="dataFimProtocolo" name="dataFim" idInput="dataFimProtocolo"></bn-datepicker>
        <small class="text-danger"
          *ngIf="formGroup.get('dataFimProtocolo')?.errors?.['dataFimProtocoloInvalida'] && formGroup.get('dataFimProtocolo')?.dirty">
          {{formGroup.get('dataFimProtocolo')?.errors?.['dataFimProtocoloInvalida']}}</small>
      </div>
    </div>

    <div class="bn-form-group col-md-6">
      <label class="form-label">
        <b>Permitir Renúncia de Limite Adicional</b>
        <i class="fa fa-question-circle ms-1 cursor-pointer"
           ngbTooltip="Indica se este Limite Adicional permite o cadastro de Renúncia de Limite Adicional por Agente Financeiro"
           placement="top">
        </i>
      </label>
      <input type="checkbox" class="form-check checkbox-gigante" formControlName="permiteRenunciaLimiteAdicional"/>
    </div>

    <div class="table-responsive">
      Selelcione o programa
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Nome</th>
          <tr>
        </thead>
        <tbody>
          <tr *ngFor="let programa of model?.limiteAdicionalProgramaBndesTranches; let i = index">
            <td>
              <span *ngIf="modoEdicao || emInclusao"><a (click)="removerPrograma(i)"><i
                    class="fa fa-trash cursor-pointer"></i></a></span>
            </td>
            <td>
              <select class="form-select" id="programa{{i}}" name="programa{{i}}"
                (change)="atribuirPrograma($event.target.value, i)" required [disabled]="!modoEdicao && !emInclusao">
                <option [value]="undefined" [selected]="!programa || !programa.programaBndesTranche">
                  (selecione programa)</option>
                <option *ngFor="let prog of programasPermitidos"
                  [value]="prog.idProgramaBndesTranche"
                  [selected]="programa && programa.programaBndesTranche?.idProgramaBndesTranche == prog.idProgramaBndesTranche">
                  {{prog.id}} - {{prog.descricaoPrograma}}</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
      <a (click)="podeAdicionarPrograma() && adicionarPrograma()" *ngIf="modoEdicao || !modoDetalhado"><i
          class="fa fa-plus-circle cursor-pointer"></i></a>
    </div>
  </form>
</div>
